/**
 * Devuelve el tipo de estado
 */
export const getStatusVariant = (status) => {
    const statusLower = status?.toLowerCase() || '';

    const statusVariants = {
        'aprob': 'success',
        'recha': 'error',
        'progreso': 'warning',
        'enviada': 'info',
        'enviado': 'info',
        'pendi': 'disabled',
    };

    // Buscar la primera palabra clave que coincida
    const matchedKey = Object.keys(statusVariants).find(key => statusLower.includes(key));

    return matchedKey ? statusVariants[matchedKey] : 'primary';
};


/**
 * Regla de negocio: estados que NO permiten edición
 */
export const isClosedStatus = (status) => {
  const variant = getStatusVariant(status);
  return ['success', 'error'].includes(variant);
};